/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetDateOfBirthBody
 */
export interface SetDateOfBirthBody {
    /**
     * Unix milliseconds.
     * @type {number}
     * @memberof SetDateOfBirthBody
     */
    dateOfBirth: number;
}

/**
 * Check if a given object implements the SetDateOfBirthBody interface.
 */
export function instanceOfSetDateOfBirthBody(value: object): value is SetDateOfBirthBody {
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    return true;
}

export function SetDateOfBirthBodyFromJSON(json: any): SetDateOfBirthBody {
    return SetDateOfBirthBodyFromJSONTyped(json, false);
}

export function SetDateOfBirthBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDateOfBirthBody {
    if (json == null) {
        return json;
    }
    return {
        
        'dateOfBirth': json['dateOfBirth'],
    };
}

export function SetDateOfBirthBodyToJSON(json: any): SetDateOfBirthBody {
    return SetDateOfBirthBodyToJSONTyped(json, false);
}

export function SetDateOfBirthBodyToJSONTyped(value?: SetDateOfBirthBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateOfBirth': value['dateOfBirth'],
    };
}

